import * as msgpub from "msgpub";
import { status_mapper } from "./common";

// TopicとUserリストを取得するためのコールバック関数
export function anyCallBackFunction(setHandler1: any, setHandler2: any, setHandlerForLog: any, setWaitForList: any, getList: any, funcName: string) {
    setWaitForList((obtainedData: string[]) => {
        setHandler1(obtainedData);
        setHandler2(obtainedData);
    });

    getList({
        callback: (status: msgpub.Status) => {
            setHandlerForLog((prevLog: string) => (prevLog + "[" + funcName + " func]status: " + status_mapper(status) + "\n"));
        }
    });
}

export function getListStr(setHandler: any, setHandlerForLog: any, setWaitForList: any, getList: any, funcName: string) {
    setWaitForList((obtainedData: any[]) => {
        setHandler(obtainedData.join("\n"));
    });

    getList({
        callback: (status: msgpub.Status) => {
            setHandlerForLog((prevLog: string) => (prevLog + "[" + funcName + " func]status: " + status_mapper(status) + "\n"));
        }
    });
}

export function searchText(input: string, list: Array<string>, setSearchedList: any) {
    setSearchedList(list.filter((e: string) => e.indexOf(input) !== -1));
}
